import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
const Login = r =>
  require.ensure([], () => r(require('../pages/login/index.vue')))

const Admin = r => require.ensure([], () => r(require('../pages/Admin.vue')))

const Index = r => require.ensure([], () => r(require('@/pages/admin/index')))
// 批量导入页面
const batchDispatcher = r =>
  require.ensure([], () => r(require('@/pages/admin/batchDispatcher')))

// --------  other ------------------

const cdnResource = r =>
  require.ensure([], () => r(require('../pages/other/cdnResource')))

// --------  other ------------------
// 商城管理
const ShopManageOrder = r =>
  require.ensure([], () => r(require('../pages/admin/shopManage/order.vue')))
const ShopManageGoods = r =>
  require.ensure([], () => r(require('../pages/admin/shopManage/goods.vue')))

const ModelAdmin = r =>
  require.ensure([], () =>
    r(require('../pages/admin/modelAdmin/modelList.vue'))
  )
const suppliesProcurement = r =>
  require.ensure([], () =>
    r(require('../pages/admin/selectModel/supplies-procurement.vue'))
  )

const modelTags = r =>
  require.ensure([], () => r(require('../pages/admin/modelTags/index.vue')))

const ModelMachineReview = r =>
  require.ensure([], () =>
    r(require('../pages/admin/modelAdmin/machineReview.vue'))
  )
const ModelGrade = r =>
  require.ensure([], () => r(require('../pages/admin/model-grade/index.vue')))
const ModelPrint = r =>
  require.ensure([], () =>
    r(require('../pages/admin/model-grade/model-print.vue'))
  )

const ModelGradeUser = r =>
  require.ensure([], () => r(require('../pages/admin/model-grade/user.vue')))
const PrintConfig = r =>
  require.ensure([], () => r(require('../pages/admin/printConfig/index.vue')))

const TobeVerifiedModel = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/model-grade/tobeVerified.vue'))
  )

const PrintConfigSupportPrint = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printConfig/supportPrint.vue'))
  )

const grievanceModel = r =>
  require.ensure([], () =>
    r(require('../pages/admin/modelAdmin/grievance-model.vue'))
  )
const photoModel = r =>
  require.ensure([], () =>
    r(require('../pages/admin/modelAdmin/photoModel.vue'))
  )
const RecommendModelList = r =>
  require.ensure([], () =>
    r(require('../pages/admin/modelAdmin/recommendModel.vue'))
  )
const memberModel = r =>
  require.ensure([], () => r(require('../pages/admin/modelAdmin/memberModel')))

const specialModel = r =>
  require.ensure([], () =>
    r(require('../pages/admin/modelAdmin/specialModel.vue'))
  )

const promotionModel = r =>
  require.ensure([], () =>
    r(require('../pages/admin/modelAdmin/promotion-model'))
  )

const exclusiveModel = r =>
  require.ensure([], () =>
    r(require('../pages/admin/modelAdmin/exclusiveModel'))
  )
const multicolorModel = r =>
  require.ensure([], () =>
    r(require('../pages/admin/modelAdmin/multicolor-model'))
  )

const smartTranslation = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/translationManage/smart-translation'))
  )

const translationProgress = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/translationManage/translation-progress'))
  )

const translateKeywords = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/translationManage/translate-keywords'))
  )

const deeplAccount = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/translationManage/deepl-account'))
  )

const ModelDetail = r =>
  require.ensure([], () => r(require('@/pages/admin/modelDetail')))
const tagsManage = r =>
  require.ensure([], () => r(require('@/pages/admin/tagsManage')))
const recommendModelTags = r =>
  require.ensure([], () => r(require('@/pages/admin/tagsManage/recommendTags')))
const recommendUserTags = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/tagsManage/recommendUserTags'))
  )
const recommendColorsTags = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/tagsManage/recommendColorsTags'))
  )
const recommendContentTags = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/tagsManage/recommendContentTags'))
  )
const blackTagList = r =>
  require.ensure([], () => r(require('@/pages/admin/tagsManage/blackTagList')))
const systemRecommendModelTags = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/tagsManage/systemRecommendModelTags'))
  )
const productTag = r =>
  require.ensure([], () => r(require('@/pages/admin/tagsManage/product-tag')))
const deviceTag = r =>
  require.ensure([], () => r(require('@/pages/admin/tagsManage/device-tag')))
const tagGroupList = r =>
  require.ensure([], () => r(require('@/pages/admin/tagsManage/tagGroupList')))
const tagUserList = r =>
  require.ensure([], () => r(require('@/pages/admin/tagsManage/tagUserList')))
const diyTag = r =>
  require.ensure([], () => r(require('@/pages/admin/tagsManage/diyTag')))
const hotWardManage = r =>
  require.ensure([], () => r(require('@/pages/admin/searchManage')))
const searchRecord = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/searchManage/searchRecord'))
  )
const bannerManage = r =>
  require.ensure([], () => r(require('@/pages/admin/bannerManage')))

const modelResourceManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/bannerManage/modelResource'))
  )

const activeManage = r =>
  require.ensure([], () => r(require('@/pages/admin/activeManage')))

const activeWhiteList = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/activeManage/activeWhiteList'))
  )
const MaterialManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/gadgetManage/material.vue'))
  )
const ToolManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/gadgetManage/toolManage.vue'))
  )
const ToolRecommend = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/gadgetManage/toolRecommend.vue'))
  )
const playManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/gadgetManage/playManage.vue'))
  )
const gameManage = r =>
  require.ensure([], () => r(require('@/pages/admin/gameManage')))
const bricsManage = r =>
  require.ensure([], () => r(require('@/pages/admin/bricsManage')))

const contestantManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/gameManage/contestantList'))
  )
const bricsContestantManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/bricsManage/contestantList'))
  )
const gameDetail = r =>
  require.ensure([], () => r(require('@/pages/admin/gameManage/gameDetail')))
const regiments = r =>
  require.ensure([], () => r(require('@/pages/admin/regimentsManage')))
const regimentsDetail = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/regimentsManage/regimentsDetail'))
  )
const reportUserManage = r =>
  require.ensure([], () => r(require('@/pages/admin/reportManage/userReport')))
const reportPostManage = r =>
  require.ensure([], () => r(require('@/pages/admin/reportManage/postReport')))

const reportDealWith = r =>
  require.ensure([], () => r(require('@/pages/admin/reportManage/dealWith')))

const reportCauseList = r =>
  require.ensure([], () => r(require('@/pages/admin/reportManage/cause')))
const commentManage = r =>
  require.ensure([], () => r(require('@/pages/admin/commentManage')))
const commentTop = r =>
  require.ensure([], () => r(require('@/pages/admin/commentManage/commentTop')))
const commentEssence = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/commentManage/commentEssence'))
  )
const feedbackManage = r =>
  require.ensure([], () => r(require('@/pages/admin/feedback')))

const feedbackQuestionType = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/feedback/questionType/index.vue'))
  )

const feedbackQuestionName = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/feedback/questionList/index.vue'))
  )

const feedbackReplyTemp = r =>
  require.ensure([], () => r(require('@/pages/admin/feedback/replyTemp')))
const feedbackWork = r =>
  require.ensure([], () => r(require('@/pages/admin/feedback/work-order')))

const BulletinManage = r =>
  require.ensure([], () => r(require('@/pages/admin/bulletinManage/notice')))
const WebPush = r =>
  require.ensure([], () => r(require('@/pages/admin/bulletinManage/push')))
const WebPushSubscribe = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/bulletinManage/push-subscribe'))
  )
const bulletinBlacklist = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/bulletinManage/bulletin-blacklist'))
  )
const createBulletin = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/bulletinManage/createBulletin'))
  )
const UserAdmin = r =>
  require.ensure([], () => r(require('../pages/admin/userAdmin/userList.vue')))

const UserStratification = r =>
  require.ensure([], () =>
    r(require('../pages/admin/userAdmin/userStratification.vue'))
  )
// fland公测用户管理
const betaUserManager = r =>
  require.ensure([], () =>
    r(require('../pages/admin/userAdmin/betaUserManager.vue'))
  )
// 内测机型管理
const betaPrinterManager = r =>
  require.ensure([], () =>
    r(require('../pages/admin/userAdmin/betaPrinterManager.vue'))
  )
const EmailTask = r =>
  require.ensure([], () => r(require('../pages/admin/email-recall/task.vue')))
const EmailTpl = r =>
  require.ensure([], () => r(require('../pages/admin/email-recall/tpl.vue')))
const EmailBulkSendingList = r =>
  require.ensure([], () =>
    r(require('../pages/admin/email-recall/bulk-sending-list.vue'))
  )
const EmailBlacklist = r =>
  require.ensure([], () =>
    r(require('../pages/admin/email-recall/email-blacklist.vue'))
  )
const memberSystem = r =>
  require.ensure([], () => r(require('../pages/admin/memberSystem/index.vue')))
const dtcManager = r =>
  require.ensure([], () =>
    r(require('../pages/admin/memberSystem/dtcManager.vue'))
  )
const messages = r =>
  require.ensure([], () => r(require('../pages/admin/messages')))
const messagesTypeManage = r =>
  require.ensure([], () => r(require('../pages/admin/messages/typeManage')))

const messagesNoticeEmail = r =>
  require.ensure([], () => r(require('../pages/admin/messages/noticeEmail')))

const cloudSpace = r =>
  require.ensure([], () =>
    r(require('../pages/admin/memberSystem/cloudSpace.vue'))
  )
const memberEquity = r =>
  require.ensure([], () =>
    r(require('../pages/admin/memberSystem/memberEquity.vue'))
  )
const platformSpace = r =>
  require.ensure([], () =>
    r(require('../pages/admin/memberSystem/platformSpace.vue'))
  )
const memberClassify = r =>
  require.ensure([], () =>
    r(require('../pages/admin/memberSystem/memberClassify.vue'))
  )
const purchaseRecord = r =>
  require.ensure([], () =>
    r(require('../pages/admin/memberSystem/purchaseRecord.vue'))
  )
const trialEquity = r =>
  require.ensure([], () =>
    r(require('../pages/admin/memberSystem/trialEquity.vue'))
  )
const robotManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/userAdmin/robotManage.vue'))
  )

const exceptionalUser = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/userAdmin/exceptionalUser.vue'))
  )
const thirdPartyImport = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/userAdmin/thirdPartyImport.vue'))
  )
const stealUser = r =>
  require.ensure([], () => r(require('@/pages/admin/userAdmin/stealUser.vue')))
const consumptionUser = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/userAdmin/consumptionUser.vue'))
  )
const consumptionVip = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/userAdmin/consumptionVip.vue'))
  )

const Authors = r =>
  require.ensure([], () => r(require('@/pages/admin/userAdmin/authors.vue')))

const userAuthList = r =>
  require.ensure([], () => r(require('@/pages/admin/userAdmin/auth-list.vue')))

const freeHandlingFee = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/userAdmin/freeHandlingFee.vue'))
  )

const whiteListAudit = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/userAdmin/whiteListAudit.vue'))
  )

const couponBusinesses = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/userAdmin/coupon-businesses.vue'))
  )

const contentManage = r =>
  require.ensure([], () =>
    r(require('../pages/admin/contentManage/content.vue'))
  )
const recommendContent = r =>
  require.ensure([], () =>
    r(require('../pages/admin/contentManage/recommendContent.vue'))
  )
const tagsTopContent = r =>
  require.ensure([], () =>
    r(require('../pages/admin/contentManage/tagsTopContent.vue'))
  )
const contentCollection = r =>
  require.ensure([], () =>
    r(require('../pages/admin/contentManage/contentCollection.vue'))
  )
const collectionContent = r =>
  require.ensure([], () =>
    r(require('../pages/admin/contentManage/collectionContent.vue'))
  )
const topContent = r =>
  require.ensure([], () =>
    r(require('../pages/admin/contentManage/topList.vue'))
  )
const timedSend = r =>
  require.ensure([], () =>
    r(require('../pages/admin/contentManage/timedSend.vue'))
  )
const RecommendUserList = r =>
  require.ensure([], () =>
    r(require('../pages/admin/userAdmin/recommendUser.vue'))
  )

// 切片参数-耗材管理
const sliceConsumableManage = r =>
  require.ensure([], () =>
    r(require('../pages/admin/sliceParams/consumable/index.vue'))
  )

// 切片参数-耗材品牌
const consumableBrand = r =>
  require.ensure([], () =>
    r(require('../pages/admin/sliceParams/consumable/brand.vue'))
  )

// 切片类型-耗材类型
const consumableTypes = r =>
  require.ensure([], () =>
    r(require('../pages/admin/sliceParams/consumable/types.vue'))
  )

// 切片参数管理  -  fdm 参数
const sliceParamsManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/sliceParams/manage/index.vue'))
  )

// 切片参数管理  -  光固化 参数
// const resinSliceParams = r =>
// require.ensure([], () =>
//   r(require('@/pages/admin/sliceParams/manage/resin.vue'))
// )

// 固件管理
const firmwareManage = r =>
  require.ensure([], () =>
    r(require('../pages/admin/firmwareManage/unList.vue'))
  )

// 软件管理
const softwareManage = r =>
  require.ensure([], () =>
    r(require('../pages/admin/firmwareManage/softwareManage.vue'))
  )

// 软件插件固件
const plugFirmware = r =>
  require.ensure([], () =>
    r(require('../pages/admin/firmwareManage/firmware.vue'))
  )

// OTA升级
const otaUpgrade = r =>
  require.ensure([], () =>
    r(require('../pages/admin/firmwareManage/otaUpgrade.vue'))
  )

// 版本管理
const versionManage = r =>
  require.ensure([], () =>
    r(require('../pages/admin/firmwareManage/versionManage.vue'))
  )
// 版本管理
const cfsManage = r =>
  require.ensure([], () =>
    r(require('../pages/admin/firmwareManage/cfsList.vue'))
  )
// 升级白名单

const upgradeWhitelist = r =>
  require.ensure([], () =>
    r(require('../pages/admin/firmwareManage/upgradeWhitelist.vue'))
  )
// 高校管理,新增高校
// const universityManage = r =>
//   require.ensure([], () =>
//     r(require('../pages/admin/universityManage/unList.vue'))
//   )
// 高校管理,数据统计
const UniversityStats = r =>
  require.ensure([], () =>
    r(require('../pages/admin/universityManage/statsData.vue'))
  )
const circleManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/circleManage/circleList.vue'))
  )
const recommendedList = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/circleManage/recommendedCircle.vue'))
  )
const columnList = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/circleManage/columnList.vue'))
  )
// 勋章管理
const medalManage = r =>
  require.ensure([], () => r(require('@/pages/admin/medalManage/medal-manage')))
// 勋章记录
const medalRecord = r =>
  require.ensure([], () => r(require('@/pages/admin/medalManage/medal-record')))
// 手动发放勋章
const medalSend = r =>
  require.ensure([], () => r(require('@/pages/admin/medalManage/medal-send')))

const categoryManage = r =>
  require.ensure([], () => r(require('@/pages/admin/categoryManage')))
// const channelManage = r =>
//   require.ensure([], () => r(require('@/pages/admin/channelManage')))
const manageAdmin = r =>
  require.ensure([], () => r(require('../pages/admin/manageAdmin/')))
const systemConfig = r =>
  require.ensure([], () => r(require('../pages/admin/systemConfig/')))
const AuthGroupManage = r =>
  require.ensure([], () => r(require('../pages/admin/authgroupManage/')))
const ConfigAuthGroup = r =>
  require.ensure([], () => r(require('../pages/admin/configAuthGroup')))
const NotFound = r =>
  require.ensure([], () => r(require('../pages/admin/NotFound.vue')))
const documentManage = r =>
  require.ensure([], () => r(require('../pages/admin/documentManage')))
const heziList = r =>
  require.ensure([], () => r(require('../pages/admin/deviceManage/hezi.vue')))
const shangyunList = r =>
  require.ensure([], () =>
    r(require('../pages/admin/deviceManage/shangyun.vue'))
  )
const printerList = r =>
  require.ensure([], () => r(require('@/pages/admin/printerManage/index.vue')))
const printerCate = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printerManage/printerCate.vue'))
  )
const printerParams = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printerManage/printerParams.vue'))
  )
const paramsTemplate = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printerManage/paramsTemplate.vue'))
  )
const laserPrinter = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printerManage/laserPrinter.vue'))
  )
const laserMaterial = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printerManage/laserMaterial.vue'))
  )
const scanPrinter = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printerManage/scanPrinter.vue'))
  )

const m1Generator = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printerManage/m1Generator.vue'))
  )

const hotDevice = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printerManage/hotDevice.vue'))
  )

const qrManage = r =>
  require.ensure([], () => r(require('@/pages/admin/qrManage/index.vue')))

const productLinkTypes = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/qrManage/productLinkTypes.vue'))
  )

const problemManage = r =>
  require.ensure([], () => r(require('@/pages/admin/problemManage/index.vue')))

const noviceTutorial = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/problemManage/noviceTutorial.vue'))
  )

const experienceList = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/experience-list/index'))
  )
const experienceRanking = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/experience-ranking/index'))
  )
const hierarchy = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/hierarchy'))
  )
const signInTask = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/signInTask'))
  )
const experienceDetail = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/experience-detail'))
  )
const BeanList = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/bean-list'))
  )
const DeliverDetail = r =>
  require.ensure([], () =>
    r(
      require('@/pages/admin/experienceManage/bean-list/components/DeliverDetail')
    )
  )
const ConsumeDetail = r =>
  require.ensure([], () =>
    r(
      require('@/pages/admin/experienceManage/bean-list/components/ConsumeDetail')
    )
  )
const UserInfo = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/bean-list/components/UserInfo'))
  )
const DeliverBean = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/deliver-bean'))
  )
const Deliver = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/deliver-bean/components/Deliver'))
  )
const Excel = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/deliver-bean/components/Excel'))
  )

const RectcleBean = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/rectcle-bean'))
  )

const BeanStatistics = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/bean-statistics'))
  )

const asyncTaskList = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/async-task'))
  )

const ladderTasks = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/ladder-tasks'))
  )
const boostTasks = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/boostTasks/list.vue'))
  )

const asyncTaskSubList = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/experienceManage/async-task/sublist'))
  )

const BeanGoodsManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/bean-goods/components/GoodsManage'))
  )
const BeanGoodsClassify = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/bean-goods/components/GoodsClassify'))
  )

const RegionalManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/bean-goods/regional-manage/index'))
  )

const CoinOrderManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/bean-goods/components/CoinOrderManage'))
  )
const BeanGoodsDetails = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/bean-goods/components/GoodsDetail'))
  )
const BeanCouponManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/bean-goods/components/CouponManage'))
  )
const BeanOrderManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/bean-goods/components/OrderManage'))
  )
// const beanDetail = r =>
//   require.ensure([], () => r(require('@/pages/admin/bean-detail')))
// const beanDetails = r =>
//   require.ensure([], () => r(require('@/pages/admin/bean-detail/details')))
// const beanProvide = r =>
//   require.ensure([], () => r(require('@/pages/admin/bean-detail/provide')))
// const beanStatistical = r =>
//   require.ensure([], () => r(require('@/pages/admin/bean-detail/statistical')))
const MobileAgreement = r =>
  require.ensure([], () => r(require('@/pages/mobilePage/agreement.vue')))
const MobileAboutUs = r =>
  require.ensure([], () => r(require('@/pages/mobilePage/aboutUs.vue')))
const MobileCancellation = r =>
  require.ensure([], () => r(require('@/pages/mobilePage/cancellation.vue')))
const Copyright = r =>
  require.ensure([], () => r(require('@/pages/mobilePage/copyright.vue')))

const IEPage = r => require.ensure([], () => r(require('@/pages/ie-page')))

const smallPage = r => require.ensure([], () => r(require('@/pages/smallPage')))

const afterSaleManage = r =>
  require.ensure([], () => r(require('@/pages/admin/afterSaleManage')))

const orderManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/afterSaleManage/orderManage'))
  )

const afterSaleServices = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/afterSaleManage/afterSaleServices'))
  )

/*
  邀请有礼
  */
// 活动管理
const activityManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/share-activity/activityManage'))
  )

// 活动列表
const activityList = r =>
  require.ensure([], () => r(require('@/pages/admin/activity/list.vue')))
// 置顶活动列表
const activityTopList = r =>
  require.ensure([], () => r(require('@/pages/admin/activity/top.vue')))
// 活动类型
const activityClassify = r =>
  require.ensure([], () => r(require('@/pages/admin/activity/classify.vue')))
// 优惠券
const activityCoupon = r =>
  require.ensure([], () => r(require('@/pages/admin/activeModel/coupon.vue')))
// 常规活动
const activeCommon = r =>
  require.ensure([], () => r(require('@/pages/admin/activeCommon')))
// 全部作品
const workList = r =>
  require.ensure([], () => r(require('@/pages/admin/activeCommon/work')))
// 获奖作品
const workPrize = r =>
  require.ensure([], () => r(require('@/pages/admin/activeCommon/prize')))
// 置顶作品
const workTop = r =>
  require.ensure([], () => r(require('@/pages/admin/activeCommon/top')))
// 优质作品
const workHighQuality = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/activeCommon/high-quality'))
  )

// 活动统计
const activityStatistics = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/share-activity/activityStatistics'))
  )

// 黑名单管理
const blackListManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/share-activity/blackListManage'))
  )
// 红人计划
const sensationManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/sensation-manage/index.vue'))
  )
// 商业模型招募
const businessModelManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/sensation-manage/businessModel.vue'))
  )

// 建模师邀请裂变
const modelerFission = r =>
  require.ensure([], () => r(require('@/pages/admin/modelerFission/index.vue')))

// 建模师邀请裂变统计
const fissionStatistics = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/modelerFission/fissionStatistics.vue'))
  )

// 文档管理
const softManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/firmwareManage/softManage.vue'))
  )

// 光固化皮肤管理
const resinSkinManage = r =>
  require.ensure([], () => r(require('@/pages/admin/resinSkinManage/index')))

// 专题管理
const topicManage = r =>
  require.ensure([], () => r(require('@/pages/admin/topicManage/list')))
const topicRecommend = r =>
  require.ensure([], () => r(require('@/pages/admin/topicManage/recommend')))
const TopicUser = r =>
  require.ensure([], () => r(require('@/pages/admin/topicManage/user')))
const TopicModels = r =>
  require.ensure([], () => r(require('@/pages/admin/topicManage/models')))
const h5Active = r =>
  require.ensure([], () => r(require('@/pages/admin/h5Active')))
const h5ActiveWhite = r =>
  require.ensure([], () => r(require('@/pages/admin/h5Active/whitelists')))
const h5ActiveBlack = r =>
  require.ensure([], () => r(require('@/pages/admin/h5Active/blacklist')))
const boostSignIn = r =>
  require.ensure([], () => r(require('@/pages/admin/h5Active/boostSignIn')))
const bulkDataManage = r =>
  require.ensure([], () => r(require('@/pages/admin/bulk-data-manage')))

/*
  打印服务
  */
// 打印服务-首页配置
const homeConfig = r =>
  require.ensure([], () => r(require('@/pages/admin/printService/homeConfig')))
// 打印服务管理
const printService = r =>
  require.ensure([], () => r(require('@/pages/admin/printService')))

// 打印服务商详情
const printDetail = r =>
  require.ensure([], () => r(require('@/pages/admin/printService/printDetail')))

// 打印服务-评价管理
const evaluateManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printService/evaluateManage'))
  )

// 打印服务-投诉商家
const complaint = r =>
  require.ensure([], () => r(require('@/pages/admin/printService/complaint')))

// 打印订单列表
const printOrder = r =>
  require.ensure([], () => r(require('@/pages/admin/printService/printOrder')))
// 打印订单详情
const printOrderDetail = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printService/printOrderDetail'))
  )
// 打印耗材管理
const consumablesManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printService/consumablesManage'))
  )
// 耗材库
const consumablesLibrary = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printService/consumablesLibrary'))
  )
// 充值订单
const rechargeOrder = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printService/rechargeOrder'))
  )
// 充值配置
const rechargeSet = r =>
  require.ensure([], () => r(require('@/pages/admin/printService/rechargeSet')))
const biFormManage = r =>
  require.ensure([], () => r(require('@/pages/admin/biFormManage/index.vue')))
const shortLinkManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/shortLinkManage/short-link'))
  )
const platformLinkManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/shortLinkManage/platform-manage'))
  )
const externalLinkManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/shortLinkManage/external-link'))
  )

// 注销管理
const logoutManage = r =>
  require.ensure([], () => r(require('@/pages/admin/logoutManage/index')))

const sliceManage = r =>
  require.ensure([], () => r(require('@/pages/admin/sliceManage/index.vue')))

// 光固化官方切片
const dlpOfficialManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/sliceManage/dlp-official.vue'))
  )
const modelOrder = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/modelAdmin/modelOrder.vue'))
  )
const websocket = r =>
  require.ensure([], () => r(require('@/pages/admin/websocket/index.vue')))
const websocketPush = r =>
  require.ensure([], () => r(require('@/pages/admin/websocket/rtcPush.vue')))
const websocketPull = r =>
  require.ensure([], () => r(require('@/pages/admin/websocket/rtcPull.vue')))
// const withdrawDeposit = r =>
//   require.ensure([], () =>
//     r(require('@/pages/admin/withdrawDeposit/index.vue'))
//   )
const moneyWithdrawDeposit = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/withdrawDeposit/moneyWithdrawDeposit.vue'))
  )
const authenticationInfo = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/financialManage/authentication-info/index.vue'))
  )

// const withdrawBlackList = r =>
//   require.ensure([], () =>
//     r(require('@/pages/admin/withdrawDeposit/withdraw-black-list.vue'))
//   )
const accumulativeInfo = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/withdrawDeposit/accumulativeInfo.vue'))
  )
const recodeManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/logManage/recodeManage.vue'))
  )
// const recodeAppManage = r =>
//   require.ensure([], () =>
//     r(require('@/pages/admin/logManage/recodeAppManage.vue'))
//   )
const videoManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/logManage/videoManage.vue'))
  )
const fissionUserManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/fission-default-template/index.vue'))
  )
const fissionGoodsManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/fission-default-template/goodsManage.vue'))
  )

const fissionDetailManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/fission-default-template/detailManage.vue'))
  )
const blacklistManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/fission-default-template/blacklist.vue'))
  )
// seo管理
const seoManage = r =>
  require.ensure([], () => r(require('@/pages/admin/seoManage/index.vue')))
// 上传文件
const uploadFile = r =>
  require.ensure([], () => r(require('@/pages/admin/uploadFile/index.vue')))

const topTenClub = r =>
  require.ensure([], () => r(require('@/pages/admin/topTenClub/index.vue')))
const topTenClubPersonal = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/topTenClub/personalList.vue'))
  )

// 礼包管理
const giftBagManage = r =>
  require.ensure([], () => r(require('@/pages/admin/giftBagManage/index.vue')))
const giftBagManageBlack = r =>
  require.ensure([], () => r(require('@/pages/admin/giftBagManage/black.vue')))
// 新手指南
const guideManage = r =>
  require.ensure([], () => r(require('@/pages/admin/guideManage/index.vue')))
// app 版本
const appVersionManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/guideManage/appVersion.vue'))
  )
// 首页配置 用户说/关于创想云
const userSaidManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/homeConfigManage/user-said-manage.vue'))
  )

const aboutCrealityManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/homeConfigManage/about-creality-manage.vue'))
  )
// 财务管理/ 充值记录
const rechargeRecord = r => {
  return require.ensure([], () =>
    r(require('@/pages/admin/financialManage/rechargeRecord/index.vue'))
  )
}
const accountFlow = r => {
  return require.ensure([], () =>
    r(require('@/pages/admin/financialManage/rechargeRecord/flow.vue'))
  )
}

// 财务管理/ 流水记录
const accountRecord = r => {
  return require.ensure([], () =>
    r(require('@/pages/admin/financialManage/account-record/index.vue'))
  )
}
const accountCredits = r => {
  return require.ensure([], () =>
    r(require('@/pages/admin/financialManage/account-record/credits.vue'))
  )
}
const aiCubeMe = r => {
  return require.ensure([], () =>
    r(require('@/pages/admin/financialManage/account-record/ai-cubeme.vue'))
  )
}

const dtcCoupons = r => {
  return require.ensure([], () =>
    r(require('@/pages/admin/financialManage/account-record/dtc-coupons.vue'))
  )
}

// 财务管理/ 创想币提现记录
const withdrawalRecord = r => {
  return require.ensure([], () =>
    r(require('@/pages/admin/financialManage/withdrawalRecord/index.vue'))
  )
}

// 财务管理/ 现金提现记录
const cashRecord = r => {
  return require.ensure([], () =>
    r(require('@/pages/admin/financialManage/cashRecord/index.vue'))
  )
}

const financialWithdrawBlack = r => {
  return require.ensure([], () =>
    r(require('@/pages/admin/financialManage/withdraw-black-list/index.vue'))
  )
}

// 财务管理/ 兑换记录
const forCuvacoinRecord = r => {
  return require.ensure([], () =>
    r(require('@/pages/admin/financialManage/forRecord/index.vue'))
  )
}

// 财务管理/ 购买记录
const FinPurchaseRecord = r => {
  return require.ensure([], () =>
    r(require('@/pages/admin/financialManage/purchaseRecord/index.vue'))
  )
}

// 财务管理/ KOL结算记录
const FinKolSettleRecord = r => {
  return require.ensure([], () =>
    r(require('@/pages/admin/financialManage/kolSettleManage/index.vue'))
  )
}
// 排行榜 用户榜 模型榜 黑名单
const rankingList = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/rankingManage/list/index.vue'))
  )
// 模型榜
const rankingListModel = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/rankingManage/model/index.vue'))
  )
// 用户榜
const rankingListUser = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/rankingManage/user/index.vue'))
  )
// 黑名单
const rankingListBlack = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/rankingManage/blacklist/index.vue'))
  )

const photo3dOrder = r =>
  require.ensure([], () => r(require('@/pages/admin/photo3d/index.vue')))
const photo3dSettlement = r =>
  require.ensure([], () => r(require('@/pages/admin/photo3d/settlement.vue')))
// 建模师入驻
const modelerIn = r =>
  require.ensure([], () => r(require('@/pages/admin/modelerIn/index.vue')))

// 年度建模师活动
const modelerInActivity = r =>
  require.ensure([], () => r(require('@/pages/admin/modelerIn/activity.vue')))
// PK选手分分组
const pkContestantGroup = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/modelerIn/pk-contestant-group.vue'))
  )
// 冬季挑战赛投票记录
const WinterContest = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/modelerIn/winter-contest.vue'))
  )
// 邮件订阅
const emailSubscribe = r =>
  require.ensure([], () => r(require('@/pages/admin/email-subscribe')))
// 3D百科
const Information = r =>
  require.ensure([], () => r(require('@/pages/admin/information')))
// KOL审核管理
const kolManage = r =>
  require.ensure([], () => r(require('@/pages/admin/kolManage/kol-manage.vue')))

// KOL结算申请管理
const kolSettleManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/kolManage/kol-settle-manage.vue'))
  )
// 荣誉墙
const specialThanks = r =>
  require.ensure([], () => r(require('@/pages/admin/special-thanks')))
// AI发放次数
const aiTimes = r =>
  require.ensure([], () => r(require('@/pages/admin/ai-tool-manage/ai-times')))
// AI结算配置
const settlementConfig = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/ai-tool-manage/settlement-config'))
  )
const pageConfig = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/ai-tool-manage/page-config'))
  )
// 金砖赛海外版
// 参赛作品
const bricsWork = r =>
  require.ensure([], () => r(require('@/pages/admin/brics-abroad/work')))
// 参赛选手
const bricsContestant = r =>
  require.ensure([], () => r(require('@/pages/admin/brics-abroad/contestant')))
// 专家权限
const bricsPermission = r =>
  require.ensure([], () => r(require('@/pages/admin/brics-abroad/permission')))

// 风控管理
const riskManage = r =>
  require.ensure([], () => r(require('@/pages/admin/risk/index')))

// IP风控管理
const ipRiskManage = r =>
  require.ensure([], () => r(require('@/pages/admin/risk/ipRisk')))

// IP白名单
const ipWhitelist = r =>
  require.ensure([], () => r(require('@/pages/admin/risk/ipWhitelist')))

// 异常用户列表
const abnormalUsers = r =>
  require.ensure([], () => r(require('@/pages/admin/risk/abnormalUsers')))

// 模型异常下载列表
const abnormalModels = r =>
  require.ensure([], () => r(require('@/pages/admin/risk/abnormalModels')))

// 作弊模型列表
const cheatingModels = r =>
  require.ensure([], () => r(require('@/pages/admin/risk/cheatingModels')))

// 金刚区
const navManage = r =>
  require.ensure([], () => r(require('@/pages/admin/navManage/index')))

// App首页Tab配置
const modelMenu = r =>
  require.ensure([], () => r(require('@/pages/admin/modelMenu/index')))

// web首页热门模型
const webHotModel = r =>
  require.ensure([], () => r(require('@/pages/admin/webHotModel/index')))

// 推荐公式
const recommendFormula = r =>
  require.ensure([], () => r(require('@/pages/admin/recommendFormula/index')))
// 切片元数据版本管理
const sliceBaseManage = r =>
  require.ensure([], () => r(require('@/pages/admin/sliceBaseManage/index')))
// ui层级管理
const uiLevelManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/sliceBaseManage/uiLevelManage.vue'))
  )
// base数据管理
const baseParams = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/sliceBaseManage/baseParams.vue'))
  )
// base数据多语言
const sliceParamsI18n = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/sliceBaseManage/sliceParamsI18n.vue'))
  )
// 新切片耗材管理
const consumableManage = r =>
  require.ensure([], () => r(require('@/pages/admin/consumableManage/index')))
// 工艺参数管理
const processParamsManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/processParamsManage/index'))
  )
// 机型参数包管理
const printerParamsManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/printerParamsManage/index'))
  )
// 模型转3mf
const Transform3mf = r =>
  require.ensure([], () => r(require('@/pages/admin/transform-3mf')))
// 机型参数包管理
const threeParamsManage = r =>
  require.ensure([], () => r(require('@/pages/admin/threeParamsManage/index')))

// 光固化--机型耗材参数
const dlpDeviceParamsManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/dlpResin/dlpDeviceParamsManage/index'))
  )

// 光固化--耗材列表
const dlpResinManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/dlpResin/dlpResinManage/index'))
  )

// 光固化--切片参数
const dlpSliceParams = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/dlpResin/dlpSliceParams/index'))
  )

// 光固化--层厚
const dlpLayerThickManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/dlpResin/dlpLayerThickManage/index'))
  )
// 助力管理
const BoostAdmin = r =>
  require.ensure([], () => r(require('@/pages/admin/boostAdmin/index')))
// 助力列表管理
const BoostList = r =>
  require.ensure([], () => r(require('@/pages/admin/boostAdmin/boostList')))
// 助力券使用流水列表
const BoostUsedList = r =>
  require.ensure([], () => r(require('@/pages/admin/boostAdmin/boostUsedList')))
// 助力券用户统计列表
const BoostUserList = r =>
  require.ensure([], () => r(require('@/pages/admin/boostAdmin/boostUserList')))

const BoostAdminPush = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/boostAdmin/boostAdminPush'))
  )
const BoostStaticsList = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/boostAdmin/boostStaticsList'))
  )

const StockoutDelayedUsers = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/dtc/stockout-delayed-users'))
  )

const CouponPackageManager = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/memberSystem/couponPackageManager.vue'))
  )

// 模型招募
const ModelRecruitModeler = r =>
  require.ensure([], () => r(require('@/pages/admin/model-recruit/modeler')))
const ModelRecruitModels = r =>
  require.ensure([], () => r(require('@/pages/admin/model-recruit/models')))
const ModelRecruitModelerUploadedModels = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/model-recruit/modeler/uploaded-models'))
  )
const ModelRecruitModeler1v1 = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/model-recruit/modeler/1v1'))
  )
const ModelRecruitModelerReferralRewards = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/model-recruit/modeler/referral-rewards'))
  )
const ModelRecruitModelerReferredUsers = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/model-recruit/modeler/referred-users'))
  )

const CoinFreezeRecord = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/financialManage/coin-freeze-record'))
  )
// 现金激励
const CashIncentivesModels = r =>
  require.ensure([], () => r(require('@/pages/admin/cash-incentives/models')))
const CashIncentivesPreparation = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/cash-incentives/models/preparation'))
  )
const CashIncentivesCurated = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/cash-incentives/models/curated'))
  )

const CashIncentivesNewcomerIncentive = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/cash-incentives/models/newcomer-incentive'))
  )

const CashIncentivesCreators = r =>
  require.ensure([], () => r(require('@/pages/admin/cash-incentives/creators')))
const CashIncentivesReview = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/cash-incentives/creators/review'))
  )
const CashIncentivesConversion = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/cash-incentives/creators/conversion'))
  )
const CashIncentivesNewcomer = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/cash-incentives/creators/newcomer'))
  )

const CashIncentivesRewardList = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/cash-incentives/creators/reward-list'))
  )
const CashIncentivesConvertOrders = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/cash-incentives/convert-orders'))
  )
const CashIncentivesRecommendModels = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/cash-incentives/models/recommend-models'))
  )

const F038Models = r =>
  require.ensure([], () => r(require('@/pages/admin/f038/models')))

const F038Album = r =>
  require.ensure([], () => r(require('@/pages/admin/f038/album')))

const F038Tags = r =>
  require.ensure([], () => r(require('@/pages/admin/f038/tags')))

const F038HelpCenter = r =>
  require.ensure([], () => r(require('@/pages/admin/f038/help-center')))

const F038VideoTutorial = r =>
  require.ensure([], () => r(require('@/pages/admin/f038/video-tutorial')))

const F038CreativityTemplate = r =>
  require.ensure([], () => r(require('@/pages/admin/f038/creativity-template')))

const F038CreativityEntry = r =>
  require.ensure([], () => r(require('@/pages/admin/f038/creativity-entry')))

const F038CourseFolder = r =>
  require.ensure([], () => r(require('@/pages/admin/f038/course-folder')))

const InspirationManagement = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/ai-tool-manage/inspiration-management/index'))
  )
const OfficialCreatPerManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/ai-tool-manage/official-creat-per-manage/index'))
  )
const OfficialInspirationManage = r =>
  require.ensure([], () =>
    r(require('@/pages/admin/ai-tool-manage/official-inspiration-manage/index'))
  )

const OperationLog = r =>
  require.ensure([], () => r(require('@/pages/admin/operationLog/list')))

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/batchDispatcher',
      component: batchDispatcher,
      meta: {
        title: '批量导入'
      }
    },
    {
      path: '/file-upload',
      component: uploadFile,
      meta: {
        title: '上传文件'
      }
    },
    // cdnResource
    {
      path: '/cdn-resource',
      component: cdnResource,
      meta: {
        title: '阿里云资源预览'
      }
    },
    {
      path: '/websocket',
      name: 'websocket',
      component: websocket,
      meta: {
        title: 'websocket'
      }
    },
    {
      path: '/rtc-push',
      name: 'rtcPush',
      component: websocketPush,
      meta: {
        title: 'rtc推流'
      }
    },
    {
      path: '/rtc-pull',
      name: 'rtcPull',
      component: websocketPull,
      meta: {
        title: 'rtc拉流'
      }
    },
    {
      path: '/login',
      component: Login,
      meta: {
        title: '创想云后台管理系统'
      }
    },
    {
      path: '/ie-page',
      name: 'ie-page',
      component: IEPage
    },
    {
      path: '/small-page',
      name: 'small-page',
      component: smallPage
    },
    {
      path: '/mobileAgreement',
      component: MobileAgreement
    },
    {
      path: '/mobile-agreement',
      component: MobileAgreement
    },
    {
      path: '/mobileAboutUs',
      component: MobileAboutUs
    },
    {
      path: '/mobile-about-us',
      component: MobileAboutUs
    },
    {
      path: '/MobileCancellation',
      component: MobileCancellation
    },
    {
      path: '/mobile-cancellation',
      component: MobileCancellation
    },
    {
      path: '/MobileCopyright',
      component: Copyright
    },
    {
      path: '/mobile-copyright',
      component: Copyright
    },
    {
      path: '/',
      component: Admin,
      children: [
        {
          path: '/f038/models',
          component: F038Models,
          meta: {
            title: 'F038-模型库'
          }
        },
        {
          path: '/f038/album',
          component: F038Album,
          meta: {
            title: 'F038-专题'
          }
        },
        {
          path: '/f038/tags',
          component: F038Tags,
          meta: {
            title: 'F038-标签'
          }
        },
        {
          path: '/f038/help-center',
          component: F038HelpCenter,
          meta: {
            title: 'F038-帮助中心'
          }
        },
        {
          path: '/f038/video-tutorial',
          component: F038VideoTutorial,
          meta: {
            title: 'F038-视频教程'
          }
        },
        {
          path: '/f038/creativity-template',
          component: F038CreativityTemplate,
          meta: {
            title: 'F038-创意模板'
          }
        },
        {
          path: '/f038/creativity-entry',
          component: F038CreativityEntry,
          meta: {
            title: 'F038-创意入口'
          }
        },
        {
          path: '/f038/course-folder',
          component: F038CourseFolder,
          meta: {
            title: 'F038-课程文件夹'
          }
        },
        {
          path: '/cash-incentives/models',
          component: CashIncentivesModels,
          meta: {
            title: '现金激励-模型总览池'
          }
        },
        {
          path: '/cash-incentives/preparation',
          component: CashIncentivesPreparation,
          meta: {
            title: '现金激励-模型预备池',
            key: '/cash-incentives/models'
          }
        },
        {
          path: '/cash-incentives/curated',
          component: CashIncentivesCurated,
          meta: {
            title: '现金激励-精选模型池',
            key: '/cash-incentives/models'
          }
        },
        {
          path: '/cash-incentives/newcomer-incentive',
          component: CashIncentivesNewcomerIncentive,
          meta: {
            title: '现金激励-新人加成模型',
            key: '/cash-incentives/models'
          }
        },
        {
          path: '/cash-incentives/creators',
          component: CashIncentivesCreators,
          meta: {
            title: '现金激励-创作者总览池'
          }
        },
        {
          path: '/cash-incentives/review',
          component: CashIncentivesReview,
          meta: {
            title: '现金激励-创作者审核池',
            key: '/cash-incentives/creators'
          }
        },
        {
          path: '/cash-incentives/conversion',
          component: CashIncentivesConversion,
          meta: {
            title: '现金激励-创作者可转换名单',
            key: '/cash-incentives/creators'
          }
        },
        {
          path: '/cash-incentives/newcomer',
          component: CashIncentivesNewcomer,
          meta: {
            title: '现金激励-新人建模师',
            key: '/cash-incentives/creators'
          }
        },
        {
          path: '/cash-incentives/reward-list',
          component: CashIncentivesRewardList,
          meta: {
            title: '现金激励-推荐有奖名单',
            key: '/cash-incentives/creators'
          }
        },
        {
          path: '/cash-incentives/recommend-models',
          component: CashIncentivesRecommendModels,
          meta: {
            title: '现金激励-推荐模型',
            key: '/cash-incentives/recommend-models'
          }
        },
        {
          path: '/cash-incentives/convert-orders',
          component: CashIncentivesConvertOrders,
          meta: {
            title: '现金激励-转换订单',
            key: '/cash-incentives/convert-orders'
          }
        },
        {
          path: '/email-subscribe',
          name: 'email-subscribe',
          component: emailSubscribe,
          meta: {
            title: '邮件订阅'
          }
        },
        {
          path: '/information',
          name: 'information',
          component: Information,
          meta: {
            title: '3D百科'
          }
        },
        {
          path: '/user-guide-manage',
          component: guideManage,
          meta: {
            title: '新手指南',
            key: '/problem-manage'
          }
        },
        {
          path: '/app-version-manage',
          component: appVersionManage,
          meta: {
            title: '版本记录',
            key: '/problem-manage'
          }
        },
        {
          path: '/novice-tutorial',
          name: 'novice-tutorial',
          component: noviceTutorial,
          meta: {
            title: '新手教程',
            key: '/problem-manage'
          }
        },
        {
          path: '',
          component: Index,
          meta: {
            title: '首页'
          }
        },
        {
          path: '/system-config',
          component: systemConfig,
          meta: {
            title: '系统配置'
          }
        },
        {
          path: '/model-admin',
          component: ModelAdmin,
          meta: {
            title: '模型管理',
            key: '/model-admin'
          }
        },
        {
          path: '/supplies-procurement',
          component: suppliesProcurement,
          meta: {
            title: '官网耗材共享模型',
            key: '/supplies-procurement'
          }
        },
        {
          path: '/model-tags',
          component: modelTags,
          meta: {
            title: '模型标签管理',
            key: '/model-tags'
          }
        },
        {
          path: '/model-machine-review',
          component: ModelMachineReview,
          meta: {
            title: '模型机审',
            key: '/model-admin'
          }
        },
        {
          path: '/model-grade',
          component: ModelGrade,
          meta: {
            title: '模型标注',
            key: '/model-grade'
          }
        },
        {
          path: '/model-print',
          component: ModelPrint,
          meta: {
            title: '模型打印验证',
            key: '/model-print'
          }
        },
        {
          path: '/model-grade/tobeVerified',
          component: TobeVerifiedModel,
          meta: {
            title: '待打印验证模型池',
            key: '/model-grade'
          }
        },
        {
          path: '/model-user',
          component: ModelGradeUser,
          meta: {
            title: '模型标注用户管理',
            key: '/model-user'
          }
        },
        {
          path: '/boost-admin',
          component: BoostAdmin,
          meta: {
            title: '助力管理',
            key: '/boost-admin'
          }
        },
        {
          path: '/boost-list',
          component: BoostList,
          meta: {
            title: '助力管理',
            key: '/boost-admin'
          }
        },
        {
          path: '/boost-user-list',
          component: BoostUserList,
          meta: {
            title: '助力券用户统计列表',
            key: '/boost-admin'
          }
        },
        {
          path: '/boost-used-list',
          component: BoostUsedList,
          meta: {
            title: '助力券使用流水列表',
            key: '/boost-admin'
          }
        },
        {
          path: '/boost-admin-push',
          component: BoostAdminPush,
          meta: {
            title: '手动发放',
            key: '/boost-admin'
          }
        },
        {
          path: '/boost-statics-list',
          component: BoostStaticsList,
          meta: {
            title: '助力流水',
            key: '/boost-admin'
          }
        },
        {
          path: '/transform-3mf',
          component: Transform3mf,
          meta: {
            title: '模型转3mf',
            key: '/transform-3mf'
          }
        },
        {
          path: '/print-config',
          component: PrintConfig,
          meta: {
            title: '打印配置管理',
            key: '/print-config'
          }
        },
        {
          path: '/print-config-support-print',
          component: PrintConfigSupportPrint,
          meta: {
            title: '支持机型',
            key: '/print-config'
          }
        },
        {
          path: '/grievance-model',
          component: grievanceModel,
          meta: {
            title: '模型申诉',
            key: '/model-admin'
          }
        },
        {
          path: '/special-model',
          component: specialModel,
          meta: {
            title: '专属模型专区',
            key: '/model-admin'
          }
        },
        {
          path: '/member-model',
          component: memberModel,
          meta: {
            title: 'VIP模型列表',
            key: '/model-admin'
          }
        },
        {
          path: '/promotion-model',
          component: promotionModel,
          meta: {
            title: '活动模型',
            key: '/model-admin'
          }
        },
        {
          path: '/exclusive-model',
          component: exclusiveModel,
          meta: {
            title: '独家模型',
            key: '/model-admin'
          }
        },
        {
          path: '/multicolor-model',
          component: multicolorModel,
          meta: {
            title: '多色模型',
            key: '/model-admin'
          }
        },
        {
          path: '/smart-translation',
          component: smartTranslation,
          meta: {
            title: '多语言管理'
          }
        },
        {
          path: '/translation-progress',
          component: translationProgress,
          meta: {
            title: '翻译进度',
            key: '/smart-translation'
          }
        },
        {
          path: '/translate-keywords',
          component: translateKeywords,
          meta: {
            title: '免翻译关键词',
            key: '/smart-translation'
          }
        },
        {
          path: '/deepl-account',
          component: deeplAccount,
          meta: {
            title: 'Deepl账号管理',
            key: '/smart-translation'
          }
        },
        {
          path: '/photo-model',
          component: photoModel,
          meta: {
            title: '拍照建模',
            key: '/model-admin'
          }
        },
        {
          path: '/category-manage',
          name: 'category-manage',
          component: categoryManage,
          meta: {
            title: '分类管理'
          }
        },
        // {
        //   path: '/channel-manage',
        //   name: 'channel-manage',
        //   component: channelManage,
        //   meta: {
        //     title: '频道管理'
        //   }
        // },
        {
          path: '/model-recommend',
          component: RecommendModelList,
          meta: {
            title: '推荐模型',
            key: '/model-admin'
          }
        },
        {
          path: '/comment-manage',
          component: commentManage,
          meta: {
            title: '评论管理'
          }
        },
        {
          path: '/comment-top',
          component: commentTop,
          meta: {
            title: '置顶评论',
            key: '/comment-manage'
          }
        },
        {
          path: '/comment-essence',
          component: commentEssence,
          meta: {
            title: '精华评论',
            key: '/comment-manage'
          }
        },
        {
          path: '/model-detail/:id/:name/:isCanEdit',
          name: 'model-detail',
          component: ModelDetail,
          meta: {
            title: '模型组详情',
            key: '/model-admin'
          }
        },
        {
          path: '/manage-admin',
          name: 'manage-admin',
          component: manageAdmin,
          meta: {
            title: '账号权限管理'
          }
        },
        {
          path: '/report-user-manage',
          name: 'report-user-manage',
          component: reportUserManage,
          meta: {
            title: '举报管理'
          }
        },
        {
          path: '/report-post-manage',
          name: 'report-post-manage',
          component: reportPostManage,
          meta: {
            title: '举报管理',
            key: '/report-user-manage'
          }
        },
        {
          path: '/report-deal-with',
          name: 'report-deal-with',
          component: reportDealWith,
          meta: {
            title: '举报处理原因',
            key: '/report-user-manage'
          }
        },
        {
          path: '/report-cause',
          name: 'report-cause',
          component: reportCauseList,
          meta: {
            title: '举报原因',
            key: '/report-user-manage'
          }
        },
        {
          path: '/hot-word-manage',
          name: 'hot-word-manage',
          component: hotWardManage,
          meta: {
            title: '搜索管理',
            key: '/hot-word-manage'
          }
        },
        {
          path: '/search-record',
          name: 'search-record',
          component: searchRecord,
          meta: {
            title: '用户搜索记录',
            key: '/hot-word-manage'
          }
        },
        {
          path: '/authgroup-manage',
          name: 'authgroup-manage',
          component: AuthGroupManage,
          meta: {
            title: '权限组管理',
            key: '/manage-admin'
          }
        },
        {
          path: '/config-auth-group/:id/:name',
          name: 'config-auth-group',
          component: ConfigAuthGroup,
          meta: {
            title: '管理员管理',
            key: '/manage-admin'
          }
        },
        {
          path: '/tags-manage',
          name: 'tags-manage',
          component: tagsManage,
          meta: {
            title: '标签管理'
          }
        },

        {
          path: '/recommend-model-tags',
          name: 'recommend-model-tags',
          component: recommendModelTags,
          meta: {
            title: '模型推荐标签',
            key: '/tags-manage'
          }
        },
        {
          path: '/recommend-content-tags',
          name: 'recommend-content-tags',
          component: recommendContentTags,
          meta: {
            title: '内容推荐标签',
            key: '/tags-manage'
          }
        },
        {
          path: '/recommend-user-tags',
          name: 'recommend-user-tags',
          component: recommendUserTags,
          meta: {
            title: '用户标签',
            key: '/tags-manage'
          }
        },
        {
          path: '/recommend-colors-tags',
          name: 'recommend-colors-tags',
          component: recommendColorsTags,
          meta: {
            title: '多色模型推荐标签',
            key: '/tags-manage'
          }
        },
        {
          path: '/black-tag-list',
          name: 'black-tag-list',
          component: blackTagList,
          meta: {
            title: '黑名单标签',
            key: '/tags-manage'
          }
        },
        {
          path: '/system-recommend-model-tags',
          name: 'system-recommend-model-tags',
          component: systemRecommendModelTags,
          meta: {
            title: '系统推荐模型标签',
            key: '/tags-manage'
          }
        },
        {
          path: '/tag-group-list',
          name: 'tag-group-list',
          component: tagGroupList,
          meta: {
            title: '标签分群',
            key: '/tags-manage'
          }
        },
        {
          path: '/tag-user-list',
          name: 'tag-user-list',
          component: tagUserList,
          meta: {
            title: '标签用户列表',
            key: '/tags-manage'
          }
        },

        {
          path: '/product-tag',
          name: 'product-tag',
          component: productTag,
          meta: {
            title: '产品标签',
            key: '/tags-manage'
          }
        },

        {
          path: '/device-tag',
          name: 'device-tag',
          component: deviceTag,
          meta: {
            title: '机型标签',
            key: '/tags-manage'
          }
        },
        {
          path: '/diy-tag',
          name: 'diy-tag',
          component: diyTag,
          meta: {
            title: '自定义标签'
          }
        },
        {
          path: '/user-admin',
          component: UserAdmin,
          meta: {
            title: '用户管理',
            key: '/user-admin'
          }
        },
        {
          path: '/user-stratification',
          component: UserStratification,
          meta: {
            title: '标签用户列表',
            key: '/user-stratification'
          }
        },
        {
          path: '/robot-manage',
          component: robotManage,
          meta: {
            title: '机器人规则列表',
            key: '/user-admin'
          }
        },
        {
          path: '/user-exceptional',
          component: exceptionalUser,
          meta: {
            title: '打赏用户列表',
            key: '/user-admin'
          }
        },
        {
          path: '/third-party-import',
          component: thirdPartyImport,
          meta: {
            title: '第三方平台导入指定用户',
            key: '/user-admin'
          }
        },
        {
          path: '/steal-user',
          component: stealUser,
          meta: {
            title: '盗用模型用户',
            key: '/user-admin'
          }
        },
        {
          path: '/auth-list',
          component: userAuthList,
          meta: {
            title: '权限用户列表',
            key: '/user-admin'
          }
        },
        {
          path: '/beta-user-manager',
          component: betaUserManager,
          meta: {
            title: '内测用户管理',
            key: '/user-admin'
          }
        },
        {
          path: '/beta-printer-manager',
          component: betaPrinterManager,
          meta: {
            title: '内测机型管理',
            key: '/user-admin'
          }
        },
        {
          path: '/coupon-businesses',
          component: couponBusinesses,
          meta: {
            title: '优惠券商家',
            key: '/user-admin'
          }
        },
        {
          path: '/free-handling-fee',
          component: freeHandlingFee,
          meta: {
            title: '提现免手续费',
            key: '/user-admin'
          }
        },
        {
          path: '/white-list-audit',
          component: whiteListAudit,
          meta: {
            title: '审核白名单',
            key: '/user-admin'
          }
        },
        {
          path: '/user-consumption',
          component: consumptionUser,
          meta: {
            title: '会员列表',
            key: '/user-admin'
          }
        },
        {
          path: '/vip-consumption',
          component: consumptionVip,
          meta: {
            title: '付费会员列表'
          }
        },
        {
          path: '/authors',
          component: Authors,
          meta: {
            title: '作者列表',
            key: '/user-admin'
          }
        },
        {
          path: '/member-system',
          component: memberSystem,
          meta: {
            title: '会员等级'
          }
        },
        {
          path: '/messages',
          component: messages,
          meta: {
            title: '消息模板'
          }
        },
        {
          path: '/messages/typeManage',
          component: messagesTypeManage,
          meta: {
            title: '消息模板类型管理',
            key: '/messages'
          }
        },
        {
          path: '/messages/noticeEmail',
          component: messagesNoticeEmail,
          meta: {
            title: '通知邮件管理',
            key: '/messages'
          }
        },
        {
          path: '/email-task',
          component: EmailTask,
          meta: {
            title: '用户召回任务列表'
          }
        },
        {
          path: '/email-tpl',
          component: EmailTpl,
          meta: {
            title: '模板管理列表',
            key: '/email-task'
          }
        },
        {
          path: '/email-bulk-sending-list',
          component: EmailBulkSendingList,
          meta: {
            title: '批量发送邮件列表',
            key: '/email-task'
          }
        },
        {
          path: '/email-blacklist',
          component: EmailBlacklist,
          meta: {
            title: '邮箱黑名单',
            key: '/email-task'
          }
        },
        {
          path: '/cloud-space',
          component: cloudSpace,
          meta: {
            title: '云存储空间',
            key: '/member-system'
          }
        },
        {
          path: '/dtc-manager',
          component: dtcManager,
          meta: {
            title: 'DTC券包列表',
            key: '/dtc-manager'
          }
        },
        {
          path: '/member-equity',
          component: memberEquity,
          meta: {
            title: '会员权益',
            key: '/member-system'
          }
        },
        {
          path: '/platform-space',
          component: platformSpace,
          meta: {
            title: '平台赠送',
            key: '/member-system'
          }
        },
        {
          path: '/member-classify',
          component: memberClassify,
          meta: {
            title: '权益分类',
            key: '/member-system'
          }
        },
        {
          path: '/purchase-record',
          component: purchaseRecord,
          meta: {
            title: '购买记录',
            key: '/member-system'
          }
        },
        {
          path: '/trial-equity',
          component: trialEquity,
          meta: {
            title: '试用权益',
            key: '/member-system'
          }
        },

        {
          path: '/content-manage',
          component: contentManage,
          meta: {
            title: '内容管理',
            key: '/content-manage'
          }
        },
        {
          path: '/top-content',
          component: topContent,
          meta: {
            title: '置顶内容列表',
            key: '/content-manage'
          }
        },
        {
          path: '/timed-send',
          component: timedSend,
          meta: {
            title: '定时内容',
            key: '/content-manage'
          }
        },
        {
          path: '/recommed-content',
          component: recommendContent,
          meta: {
            title: '推荐内容列表',
            key: '/content-manage'
          }
        },
        {
          path: '/tags-top-content',
          component: tagsTopContent,
          meta: {
            title: '标签置顶内容',
            key: '/content-manage'
          }
        },
        {
          path: '/content-collection',
          component: contentCollection,
          meta: {
            title: '内容合辑',
            key: '/content-manage'
          }
        },
        {
          path: '/collection-content',
          component: collectionContent,
          name: 'collection-content',
          meta: {
            title: '内容管理',
            key: '/content-manage'
          }
        },
        {
          path: '/user-recommend',
          component: RecommendUserList,
          meta: {
            title: '推荐用户列表',
            key: '/user-admin'
          }
        },
        {
          path: '/medal-manage',
          name: 'medal-manage',
          component: medalManage,
          meta: {
            title: '勋章管理',
            key: '/medal-manage'
          }
        },
        {
          path: '/sensation-manage',
          name: 'sensation-manage',
          component: sensationManage,
          meta: {
            title: '红人计划',
            key: '/sensation-manage'
          }
        },
        {
          path: '/business-model-manage',
          name: 'business-model-manage',
          component: businessModelManage,
          meta: {
            title: '商业模型招募',
            key: '/sensation-manage'
          }
        },

        {
          path: '/medal-record',
          name: 'medal-record',
          component: medalRecord,
          meta: {
            title: '勋章领取记录',
            key: '/medal-manage'
          }
        },
        {
          path: '/medal-send',
          name: 'medal-send',
          component: medalSend,
          meta: {
            title: '手动发送勋章',
            key: '/medal-manage'
          }
        },
        {
          path: '/circle-manage',
          name: 'circle-manage',
          component: circleManage,
          meta: {
            title: '圈子管理',
            key: '/circle-manage'
          }
        },
        {
          path: '/recommended-list',
          name: 'recommended-list',
          component: recommendedList,
          meta: {
            title: '圈子推荐列表',
            key: '/circle-manage'
          }
        },
        {
          path: '/column-list',
          name: 'column-list',
          component: columnList,
          meta: {
            title: '圈子栏目列表',
            key: '/circle-manage'
          }
        },
        {
          path: '/feedback',
          name: 'feedback',
          component: feedbackManage,
          meta: {
            title: '反馈和日志'
          }
        },
        {
          path: '/feedback/work-order',
          name: 'workorder',
          component: feedbackWork,
          meta: {
            title: '工单列表'
          }
        },
        {
          path: '/feedback/reply-temp',
          name: 'feedbackReplyTemp',
          component: feedbackReplyTemp,
          meta: {
            title: '回复模板',
            key: '/feedback'
          }
        },
        {
          path: '/feedback/question-tag',
          name: 'feedbackQuestionType',
          component: feedbackQuestionType,
          meta: {
            title: '反馈和日志-问题标签',
            key: '/feedback'
          }
        },
        {
          path: '/feedback/question-type',
          name: 'feedbackQuestionName',
          component: feedbackQuestionName,
          meta: {
            title: '工单列表-问题类型',
            key: '/feedback'
          }
        },
        {
          path: '/recode-manage',
          name: 'recode-manage',
          component: recodeManage,
          meta: {
            title: '设备日志',
            key: '/feedback'
          }
        },
        {
          path: '/bulletin-manage',
          name: 'bulletin-manage',
          component: BulletinManage,
          meta: {
            title: '公告管理'
          }
        },
        {
          path: '/push',
          name: 'push',
          component: WebPush,
          meta: {
            title: 'Web推送',
            key: '/bulletin-manage'
          }
        },
        {
          path: '/push-subscribe',
          name: 'push-subscribe',
          component: WebPushSubscribe,
          meta: {
            title: 'Web推送订阅',
            key: '/bulletin-manage'
          }
        },
        {
          path: '/bulletin-blacklist',
          name: 'bulletin-blacklist',
          component: bulletinBlacklist,
          meta: {
            title: '公告黑名单',
            key: '/bulletin-blacklist'
          }
        },
        {
          path: '/create-bulletin/:id',
          name: 'create-bulletin',
          component: createBulletin,
          meta: {
            title: '公告管理',
            key: '/bulletin-manage'
          }
        },
        {
          path: '/banner-manage',
          name: 'banner-manage',
          component: bannerManage,
          meta: {
            title: '广告管理'
          }
        },
        {
          path: '/banner-manage/model-resource',
          name: 'model-resource',
          component: modelResourceManage,
          meta: {
            title: '推荐列表资源位',
            key: '/banner-manage/model-resource'
          }
        },
        {
          path: '/material-manage',
          name: 'material-manage',
          component: MaterialManage,
          meta: {
            title: '素材配置',
            key: '/tool-manage'
          }
        },
        {
          path: '/tool-manage',
          name: 'tool-manage',
          component: ToolManage,
          meta: {
            title: '小工具列表',
            key: '/tool-manage'
          }
        },
        {
          path: '/tool-recommend',
          name: 'tool-recommend',
          component: ToolRecommend,
          meta: {
            title: '小工具推荐列表',
            key: '/tool-manage'
          }
        },
        {
          path: '/play-manage',
          name: 'play-manage',
          component: playManage,
          meta: {
            title: '素材分类',
            key: '/tool-manage'
          }
        },
        {
          path: '/activity-list',
          name: 'activity-list',
          component: activityList,
          meta: {
            title: '活动列表'
          }
        },
        {
          path: '/activity-top-list',
          name: 'activity-top-list',
          component: activityTopList,
          meta: {
            title: '置顶列表',
            key: '/activity-list'
          }
        },
        {
          path: '/activity-classify',
          name: 'activity-classify',
          component: activityClassify,
          meta: {
            title: '活动类型',
            key: '/activity-list'
          }
        },
        {
          path: '/activity-coupon',
          name: 'activity-coupon',
          component: activityCoupon,
          meta: {
            title: '优惠券'
          }
        },
        {
          path: '/active-common',
          name: 'active-common',
          component: activeCommon,
          meta: {
            title: '常规活动'
          }
        },
        {
          path: '/work-list',
          name: 'work-list',
          component: workList,
          meta: {
            title: '全部作品',
            key: '/active-common'
          }
        },
        {
          path: '/work-prize',
          name: 'work-prize',
          component: workPrize,
          meta: {
            title: '获奖作品',
            key: '/active-common'
          }
        },
        {
          path: '/work-top',
          name: 'work-top',
          component: workTop,
          meta: {
            title: '置顶作品',
            key: '/active-common'
          }
        },
        {
          path: '/work-high-quality',
          name: 'workHighQuality',
          component: workHighQuality,
          meta: {
            title: '优质作品',
            key: '/active-common'
          }
        },
        {
          path: '/active-manage',
          name: 'active-manage',
          component: activeManage,
          meta: {
            title: '活动管理'
          }
        },
        {
          path: '/gift-bag-manage',
          name: 'gift-bag-manage',
          component: giftBagManage,
          meta: {
            title: '礼包活动'
          }
        },
        {
          path: '/gift-bag-manage/black',
          name: 'gift-bag-manage-black',
          component: giftBagManageBlack,
          meta: {
            title: '礼包列表'
          }
        },
        {
          path: '/top-ten-club',
          component: topTenClub,
          meta: {
            title: '千团行动社团圈子列表'
          }
        },
        {
          path: '/personal-list',
          component: topTenClubPersonal,
          meta: {
            title: '社团个人贡献列表'
          }
        },
        {
          path: '/active-white-list',
          name: 'active-white-list',
          component: activeWhiteList,
          meta: {
            title: '活动白名单',
            key: '/active-manage'
          }
        },
        {
          path: '/game-manage',
          name: 'game-manage',
          component: gameManage,
          meta: {
            title: '国赛管理'
          }
        },
        {
          path: '/contestant-manage',
          name: 'contestant-manage',
          component: contestantManage,
          meta: {
            title: '国赛管理',
            key: '/game-manage'
          }
        },
        {
          path: '/game-detail/:id',
          name: 'game-detail',
          component: gameDetail,
          meta: {
            title: '国赛管理',
            key: '/game-manage'
          }
        },
        {
          path: '/regiments',
          name: 'regiments',
          component: regiments,
          meta: {
            title: '千团活动'
          }
        },
        {
          path: '/regiments-detail/:id',
          name: 'regiments-detail',
          component: regimentsDetail,
          meta: {
            title: '千团活动'
          }
        },
        {
          path: '/brics-manage',
          name: 'brics-manage',
          component: bricsManage,
          meta: {
            title: '金砖赛管理'
          }
        },
        {
          path: '/brics-contestant-manage',
          name: 'brics-contestant-manage',
          component: bricsContestantManage,
          meta: {
            title: '金砖赛管理',
            key: '/brics-manage'
          }
        },
        // 高校管理
        // {
        //   path: '/university-manage',
        //   name: 'university-manage',
        //   component: universityManage,
        //   meta: {
        //     title: '高校管理',
        //     key: '/university-manage'
        //   }
        // },
        // 数据统计
        {
          path: '/university-stats',
          name: 'university-stats',
          component: UniversityStats,
          meta: {
            title: '高校管理',
            key: '/university-manage'
          }
        },
        // 固件管理
        {
          path: '/firmware-manage',
          name: 'firmware-manage',
          component: firmwareManage,
          meta: {
            title: '软固件管理',
            key: '/firmware-manage'
          }
        },
        {
          path: '/software-manage',
          name: 'software-manage',
          component: softwareManage,
          meta: {
            title: '软件管理',
            key: '/firmware-manage'
          }
        },
        // 插件软件固件
        {
          path: '/plug-firmware',
          name: 'plug-firmware',
          component: plugFirmware,
          meta: {
            title: '软件&插件&固件',
            key: '/firmware-manage'
          }
        },
        // ota升级
        {
          path: '/ota-upgrade',
          name: 'ota-upgrade',
          component: otaUpgrade,
          meta: {
            title: 'OTA升级',
            key: '/firmware-manage'
          }
        },
        {
          path: '/version-manage',
          name: 'version-manage',
          component: versionManage,
          meta: {
            title: '版本管理',
            key: '/firmware-manage'
          }
        },
        {
          path: '/cfs-manage',
          name: 'cfs-manage',
          component: cfsManage,
          meta: {
            title: 'CFS管理',
            key: '/firmware-manage'
          }
        },
        {
          path: '/upgrade-whitelist',
          name: 'upgrade-whitelist',
          component: upgradeWhitelist,
          meta: {
            title: '升级白名单',
            key: '/firmware-manage'
          }
        },
        {
          path: '/document-manage',
          name: 'document-manage',
          component: documentManage,
          meta: {
            title: '分享文案管理'
          }
        },
        {
          path: '/qr-manage',
          name: 'qr-manage',
          component: qrManage,
          meta: {
            title: '产品管理'
          }
        },
        {
          path: '/product-link-types',
          name: 'product-link-types',
          component: productLinkTypes,
          meta: {
            title: '配置链接类型',
            key: '/qr-manage'
          }
        },

        {
          path: '/problem-manage',
          name: 'problem-manage',
          component: problemManage,
          meta: {
            title: '常见问题管理'
          }
        },
        {
          path: '/hezi-list',
          name: 'hezi-list',
          component: heziList,
          meta: {
            title: '设备管理'
          }
        },
        {
          path: '/shangyun-list',
          name: 'shangyun-list',
          component: shangyunList,
          meta: {
            title: '尚云列表',
            key: '/hezi-list'
          }
        },
        {
          path: '/slice-consumable-manage',
          name: 'slice-consumable-manage',
          component: sliceConsumableManage,
          meta: {
            title: '耗材管理'
          }
        },
        {
          path: '/consumable-brand',
          name: 'consumable-brand',
          component: consumableBrand,
          meta: {
            title: '耗材品牌'
          }
        },
        {
          path: '/consumable-types',
          name: 'consumable-types',
          component: consumableTypes,
          meta: {
            title: '耗材类型'
          }
        },
        {
          path: '/printer-manage',
          name: 'printer-manage',
          component: printerList,
          meta: {
            title: '打印机管理'
          }
        },
        {
          path: '/printer-category',
          name: 'printer-category',
          component: printerCate,
          meta: {
            title: '打印机类型列表',
            key: '/printer-manage'
          }
        },
        {
          path: '/printer-params',
          name: 'printer-params',
          component: printerParams,
          meta: {
            title: '打印机参数',
            key: '/printer-manage'
          }
        },
        {
          path: '/params-template',
          name: 'params-template',
          component: paramsTemplate,
          meta: {
            title: '参数模板',
            key: '/printer-manage'
          }
        },
        {
          path: '/laser-printer',
          name: 'laser-printer',
          component: laserPrinter,
          meta: {
            title: '激光雕刻机列表',
            key: '/printer-manage'
          }
        },
        {
          path: '/laser-material',
          name: 'laser-material',
          component: laserMaterial,
          meta: {
            title: '雕刻材质列表',
            key: '/printer-manage'
          }
        },
        {
          path: '/scan-printer',
          name: 'scan-printer',
          component: scanPrinter,
          meta: {
            title: '扫描仪列表',
            key: '/printer-manage'
          }
        },
        {
          path: '/m1-generator',
          name: 'm1-generator',
          component: m1Generator,
          meta: {
            title: 'M1生成器列表',
            key: '/printer-manage'
          }
        },
        {
          path: '/hot-device',
          name: 'hot-device',
          component: hotDevice,
          meta: {
            title: '热门机型',
            key: '/printer-manage'
          }
        },
        {
          path: '/slice-params-manage',
          name: 'slice-params-manage',
          component: sliceParamsManage,
          meta: {
            title: 'FDM-切片参数管理',
            key: '/slice-params-manage?tab=1'
          }
        },
        {
          path: '/experience-list',
          name: 'experience-list',
          component: experienceList,
          meta: {
            title: '任务列表',
            key: '/experience-list'
          }
        },
        {
          path: '/experience-ranking',
          name: 'experience-ranking',
          component: experienceRanking,
          meta: {
            title: '经验值明细',
            key: '/experience-list'
          }
        },
        {
          path: '/bean-list',
          name: 'bean-list',
          component: BeanList,
          meta: {
            title: '酷维豆明细',
            key: '/experience-list'
          }
        },
        {
          path: '/bean-list/deliver-detail/:id/:date',
          name: 'deliver-detail',
          component: DeliverDetail,
          meta: {
            title: '酷维豆明细',
            key: '/experience-list'
          }
        },
        {
          path: '/bean-list/consume-detail/:type/:date',
          name: 'consume-detail',
          component: ConsumeDetail,
          meta: {
            title: '酷维豆明细',
            key: '/experience-list'
          }
        },
        {
          path: '/bean-list/userinfo/:id/:type',
          name: 'userinfo',
          component: UserInfo,
          meta: {
            title: '酷维豆明细',
            key: '/experience-list'
          }
        },
        {
          path: '/deliver-bean',
          name: 'deliver-bean',
          component: DeliverBean,
          meta: {
            title: '手动发豆',
            key: '/experience-list'
          }
        },
        {
          path: '/deliver-bean/deliver',
          name: 'deliver',
          component: Deliver,
          meta: {
            title: '手动发豆',
            key: '/experience-list'
          }
        },
        {
          path: '/deliver-bean/excel',
          name: 'excel',
          component: Excel,
          meta: {
            title: '手动发豆',
            key: '/experience-list'
          }
        },
        {
          path: '/rectcle-bean',
          name: 'rectcleBean',
          component: RectcleBean,
          meta: {
            title: '收回酷维豆',
            key: '/experience-list'
          }
        },
        {
          path: '/bean-statistics',
          name: 'bean-statistics',
          component: BeanStatistics,
          meta: {
            title: '酷维豆统计',
            key: '/experience-list'
          }
        },
        {
          path: '/async-tasklist',
          name: 'async-tasklist',
          component: asyncTaskList,
          meta: {
            title: '异步任务管理'
          }
        },
        {
          path: '/ladder-tasks',
          name: 'ladder-tasks',
          component: ladderTasks,
          meta: {
            title: '阶梯任务管理'
          }
        },
        {
          path: '/boost-tasks',
          name: 'boost-tasks',
          // 暂时只有一个黑名单,后续增加列表时这里的命名需要更改
          component: boostTasks,
          meta: {
            title: '激励计划管理'
          }
        },
        {
          path: '/async-tasklist/sublist',
          name: 'async-tasklist-sublist',
          component: asyncTaskSubList,
          meta: {
            title: '子任务列表'
          }
        },
        {
          path: '/bean-goods/goods-manage',
          name: 'bean-goods_manage',
          component: BeanGoodsManage,
          meta: {
            title: '酷维豆兑换商品',
            key: '/bean-goods/goods-manage'
          }
        },
        {
          path: '/bean-goods/goods-classify',
          name: 'bean-goods_classify',
          component: BeanGoodsClassify,
          meta: {
            title: '酷维豆商品分类',
            key: '/bean-goods/goods-manage'
          }
        },
        {
          path: '/bean-goods/regional-manage',
          name: 'regional-manage',
          component: RegionalManage,
          meta: {
            title: '地区管理',
            key: '/bean-goods/goods-manage'
          }
        },
        {
          path: '/bean-goods/goods-details/:id',
          name: 'bean-goods_details',
          component: BeanGoodsDetails,
          meta: {
            title: '酷维豆商品详情',
            key: '/bean-goods/goods-manage'
          }
        },
        {
          path: '/bean-goods/coupon-manage',
          name: 'bean-goods_coupon',
          component: BeanCouponManage,
          meta: {
            title: '券码管理',
            key: '/bean-goods/goods-manage'
          }
        },
        {
          path: '/bean-goods/order-manage',
          name: 'bean-goods_order',
          component: BeanOrderManage,
          meta: {
            title: '酷维豆兑换订单',
            key: '/bean-goods/goods-manage'
          }
        },
        {
          path: '/bean-goods/coin-order-manage',
          name: 'coin-order-manage',
          component: CoinOrderManage,
          meta: {
            title: '创想币兑换订单',
            key: '/bean-goods/goods-manage'
          }
        },
        // {
        //   path: '/bean-detail',
        //   name: 'bean-detail',
        //   component: beanDetail,
        //   meta: {
        //     title: '酷维豆明细'
        //   }
        // },
        // {
        //   path: '/bean-detail/details',
        //   name: 'bean-details',
        //   component: beanDetails,
        //   meta: {
        //     title: '酷维豆明细'
        //   }
        // },
        // {
        //   path: '/bean-detail/provide',
        //   name: 'bean-provide',
        //   component: beanProvide,
        //   meta: {
        //     title: '手动发豆'
        //   }
        // },
        // {
        //   path: '/bean-detail/statistical',
        //   name: 'bean-provide',
        //   component: beanStatistical,
        //   meta: {
        //     title: '酷维豆统计'
        //   }
        // },
        {
          path: '/hierarchy',
          name: 'hierarchy',
          component: hierarchy,
          meta: {
            title: '等级权益',
            key: '/experience-list'
          }
        },
        {
          path: '/sign-in-task',
          name: 'signInTask',
          component: signInTask,
          meta: {
            title: '签到配置列表',
            key: '/experience-list'
          }
        },
        {
          path: '/experience-detail',
          name: 'experience-detail',
          component: experienceDetail,
          meta: {
            title: '明细列表',
            key: '/experience-list'
          }
        },
        {
          path: '/afterSale-manage',
          name: 'afterSale-manage',
          component: afterSaleManage,
          meta: {
            title: '商品管理'
          }
        },
        {
          path: '/order-manage',
          name: 'order-manage',
          component: orderManage,
          meta: {
            title: '订单管理'
          }
        },
        {
          path: '/afterSale-services',
          name: 'afterSale-services',
          component: afterSaleServices,
          meta: {
            title: '售后服务申请列表'
          }
        },
        {
          path: '/h5-active-manage',
          name: 'h5-active-manage',
          component: h5Active,
          meta: {
            title: '抽奖活动',
            key: '/h5-active-manage'
          }
        },
        {
          path: '/draw-whitelist',
          name: 'draw-whitelist',
          component: h5ActiveWhite,
          meta: {
            title: '抽奖活动',
            key: '/h5-active-manage'
          }
        },
        {
          path: '/draw-blacklist',
          name: 'draw-blacklist',
          component: h5ActiveBlack,
          meta: {
            title: '抽奖活动',
            key: '/h5-active-manage'
          }
        },
        {
          path: '/boost-signin-manage',
          name: 'boost-signin-manage',
          component: boostSignIn,
          meta: {
            title: '助力签到抽奖',
            key: '/boost-signin-manage'
          }
        },
        {
          path: '/bulk-data-manage',
          name: 'bulk-data-manage',
          component: bulkDataManage,
          meta: {
            title: '批量数据管理'
          }
        },
        {
          path: '/share-activity-manage',
          name: 'share-activity-manage',
          component: activityManage,
          meta: {
            title: '邀请有礼'
          }
        },
        {
          path: '/share-activity-statistics',
          name: 'share-activity-statistics',
          component: activityStatistics,
          meta: {
            title: '活动统计'
          }
        },
        {
          path: '/black-list-manage',
          name: 'black-list-manage',
          component: blackListManage,
          meta: {
            title: '黑名单管理'
          }
        },
        {
          path: '/modeler-fission-activity',
          name: 'modeler-fission-activity',
          component: modelerFission,
          meta: {
            title: '邀请建模师裂变'
          }
        },
        {
          path: '/modeler-fission-statistics',
          name: 'modeler-fission-statistics',
          component: fissionStatistics,
          meta: {
            title: '活动统计',
            key: '/modeler-fission-activity'
          }
        },
        {
          path: '/soft-manage',
          name: 'soft-manage',
          component: softManage,
          meta: {
            title: '说明文档'
          }
        },
        {
          path: '/resin-skin-manage',
          name: 'resin-skin-manage',
          component: resinSkinManage,
          meta: {
            title: '光固化皮肤管理'
          }
        },
        {
          path: '/bi-form-manage',
          name: 'bi-form',
          component: biFormManage,
          meta: {
            title: 'bi报表'
          }
        },
        {
          path: '/seo-manage',
          name: 'seo-manage',
          component: seoManage,
          meta: {
            title: 'seo管理'
          }
        },
        {
          path: '/topic-manage/list',
          name: 'TopicManage',
          component: topicManage,
          meta: {
            title: '专题管理'
          }
        },
        {
          path: '/topic-manage/recommend',
          name: 'TopicRecommend',
          component: topicRecommend,
          meta: {
            title: '推荐专题',
            key: '/topic-manage/list'
          }
        },
        {
          path: '/topic-manage/user',
          name: 'TopicUser',
          component: TopicUser,
          meta: {
            title: '指定用户',
            key: '/topic-manage/list'
          }
        },
        {
          path: '/topic-manage/models/:id',
          name: 'TopicModels',
          component: TopicModels,
          meta: {
            title: '用户投稿模型',
            key: '/topic-manage/models'
          }
        },
        {
          path: '/home-config',
          name: 'home-config',
          component: homeConfig,
          meta: {
            title: '首页管理'
          }
        },
        {
          path: '/evaluate-manage',
          name: 'evaluate-manage',
          component: evaluateManage,
          meta: {
            title: '评价管理'
          }
        },
        {
          path: '/complaint',
          name: 'complaint',
          component: complaint,
          meta: {
            title: '投诉商家'
          }
        },
        {
          path: '/print-service',
          name: 'print-service',
          component: printService,
          meta: {
            title: '打印服务管理'
          }
        },
        {
          path: '/print-detail/:id',
          name: 'print-detail',
          component: printDetail,
          meta: {
            title: '打印服务商详情',
            key: '/print-service'
          }
        },
        {
          path: '/print-order',
          name: 'print-order',
          component: printOrder,
          meta: {
            title: '打印订单',
            key: '/print-service'
          }
        },
        {
          path: '/print-order-detail/:id',
          name: 'print-order-detail',
          component: printOrderDetail,
          meta: {
            title: '打印订单详情',
            key: '/print-service'
          }
        },
        {
          path: '/consumables-library',
          name: 'consumables-library',
          component: consumablesLibrary,
          meta: {
            title: '耗材库',
            key: '/print-service'
          }
        },
        {
          path: '/consumables-manage',
          name: 'consumables-manage',
          component: consumablesManage,
          meta: {
            title: '耗材管理',
            key: '/print-service'
          }
        },
        {
          path: '/recharge-order',
          name: 'recharge-order',
          component: rechargeOrder,
          meta: {
            title: '充值订单',
            key: '/recharge-set'
          }
        },
        {
          path: '/recharge-set',
          name: 'recharge-set',
          component: rechargeSet,
          meta: {
            title: '充值配置'
          }
        },
        {
          path: '/short-link-manage',
          name: 'short-link-manage',
          component: shortLinkManage,
          meta: {
            title: '短链管理'
          }
        },
        {
          path: '/risk-manage',
          name: 'RiskManage',
          component: riskManage,
          meta: {
            title: '风控管理'
          }
        },
        {
          path: '/ip-risk-manage',
          name: 'IpRiskManage',
          component: ipRiskManage,
          meta: {
            title: 'IP风控管理',
            key: '/risk-manage'
          }
        },
        {
          path: '/ip-whitelist',
          name: 'IpWhitelist',
          component: ipWhitelist,
          meta: {
            title: 'IP白名单',
            key: '/risk-manage'
          }
        },
        {
          path: '/abnormal-users',
          name: 'AbnormalUsers',
          component: abnormalUsers,
          meta: {
            title: '异常用户列表',
            key: '/risk-manage'
          }
        },
        {
          path: '/abnormal-models',
          name: 'AbnormalModels',
          component: abnormalModels,
          meta: {
            title: '模型异常下载列表',
            key: '/risk-manage'
          }
        },
        {
          path: '/cheating-models',
          name: 'CheatingModels',
          component: cheatingModels,
          meta: {
            title: '作弊模型列表',
            key: '/risk-manage'
          }
        },
        {
          path: '/nav-manage',
          name: 'NavManage',
          component: navManage,
          meta: {
            title: '金刚区菜单'
          }
        },
        {
          path: '/model-menu',
          name: 'ModelMenu',
          component: modelMenu,
          meta: {
            title: 'App首页Tab配置'
          }
        },
        {
          path: '/web-hot-model',
          name: 'WebHotModel',
          component: webHotModel,
          meta: {
            title: 'web首页热门模型'
          }
        },
        {
          path: '/user-said-manage',
          name: 'user-said-manage',
          component: userSaidManage,
          meta: {
            title: '用户说',
            key: '/user-said-manage'
          }
        },
        {
          path: '/about-creality-manage',
          name: 'about-creality-manage',
          component: aboutCrealityManage,
          meta: {
            title: '关于创想云',
            key: '/user-said-manage'
          }
        },
        {
          path: '/recommend-formula',
          name: 'recommend-formula',
          component: recommendFormula,
          meta: {
            title: '推荐公式',
            key: '/recommend-formula'
          }
        },
        {
          path: '/link-platform-manage',
          name: 'link-platform-manage',
          component: platformLinkManage,
          meta: {
            title: '外链渠道',
            key: '/short-link-manage'
          }
        },
        {
          path: '/external-link-manage',
          name: 'external-link-manage',
          component: externalLinkManage,
          meta: {
            title: '外链管理',
            key: '/short-link-manage'
          }
        },
        {
          path: '/logout-manage',
          name: 'logout-manage',
          component: logoutManage,
          meta: {
            title: '注销管理'
          }
        },
        {
          path: '/slice-manage',
          name: 'slice-manage',
          component: sliceManage,
          meta: {
            title: '切片管理'
          }
        },
        {
          path: '/dlp-official-manage',
          name: 'dlp-official-manage',
          component: dlpOfficialManage,
          meta: {
            title: '光固化官方切片管理'
          }
        },
        {
          path: '/fission-default-user',
          name: 'fission-default-user',
          component: fissionUserManage,
          meta: {
            title: '参与活动用户管理'
          }
        },
        {
          path: '/active-goods-manage',
          name: 'active-goods-manage',
          component: fissionGoodsManage,
          meta: {
            title: '兑换商品管理'
          }
        },
        {
          path: '/active-detail-manage',
          name: 'active-detail-manage',
          component: fissionDetailManage,
          meta: {
            title: '邀请明细'
          }
        },
        {
          path: '/active-blacklist-manage',
          name: 'active-blacklist-manage',
          component: blacklistManage,
          meta: {
            title: '活动黑名单'
          }
        },
        {
          path: '/model-order',
          name: 'model-order',
          component: modelOrder,
          meta: {
            title: '模型付费订单',
            key: '/model-admin'
          }
        },
        // {
        //   path: '/withdraw-deposit',
        //   name: 'withdraw-deposit',
        //   component: withdrawDeposit,
        //   meta: {
        //     title: '创想币提现记录'
        //   }
        // },
        // {
        //   path: '/authentication-info',
        //   name: 'authentication-info',
        //   component: authenticationInfo,
        //   meta: {
        //     title: '认证信息'
        //   }
        // },
        // {
        //   path: '/withdraw-black-list',
        //   name: 'withdraw-black-list',
        //   component: withdrawBlackList,
        //   meta: {
        //     title: '提现黑名单'
        //   }
        // },
        {
          path: '/accumulative-info',
          name: 'accumulative-info',
          component: accumulativeInfo,
          meta: {
            title: '当月累计提现'
          }
        },
        {
          path: '/money-withdraw-deposit',
          name: 'money-withdraw-deposit',
          component: moneyWithdrawDeposit,
          meta: {
            title: '现金提现记录'
          }
        },
        {
          path: '/video-manage',
          name: 'video-manage',
          component: videoManage,
          meta: {
            title: '延时视频管理'
          }
        },
        // 财务管理路由 -----

        {
          path: '/financial-manage/account-record',
          name: 'account-record',
          component: accountRecord,
          meta: {
            key: '/financial-manage/account-record',
            title: '流水记录'
          }
        },
        {
          path: '/financial-manage/account-credits',
          name: 'account-credits',
          component: accountCredits,
          meta: {
            key: '/financial-manage/account-record',
            title: '流水记录'
          }
        },
        {
          path: '/financial-manage/ai-cubeme',
          name: 'ai-cubeme',
          component: aiCubeMe,
          meta: {
            key: '/financial-manage/account-record',
            title: 'AI-CubeMe'
          }
        },
        {
          path: '/financial-manage/dtc-coupons',
          name: 'dtc-coupons',
          component: dtcCoupons,
          meta: {
            key: '/financial-manage/account-record',
            title: 'DTC折扣券包'
          }
        },
        {
          path: '/financial-manage/recharge-record',
          name: 'recharge-record',
          component: rechargeRecord,
          meta: {
            title: '充值记录'
          }
        },
        {
          path: '/financial-manage/flow',
          name: 'flow',
          component: accountFlow,
          meta: {
            title: '官方账号流水',
            key: '/financial-manage/recharge-record'
          }
        },
        {
          path: '/financial-manage/withdrawal-record',
          name: 'withdrawal-record',
          component: withdrawalRecord,
          meta: {
            title: '提现记录'
          }
        },
        {
          path: '/financial-manage/cash-record',
          name: 'cash-record',
          component: cashRecord,
          meta: {
            title: '现金提现记录',
            key: '/financial-manage/withdrawal-record'
          }
        },
        {
          path: '/financial-manage/withdraw-black-list',
          name: 'financial-withdraw-black',
          component: financialWithdrawBlack,
          meta: {
            title: '提现黑名单',
            key: '/financial-manage/withdrawal-record'
          }
        },
        {
          path: '/financial-manage/coin-freeze-record',
          name: 'coin-freeze-record',
          component: CoinFreezeRecord,
          meta: {
            title: '创想币冻结记录',
            key: '/financial-manage/withdrawal-record'
          }
        },
        {
          path: '/financial-manage/authentication-info',
          name: 'authentication-info',
          component: authenticationInfo,
          meta: {
            title: '认证信息',
            key: '/financial-manage/withdrawal-record'
          }
        },
        {
          path: '/financial-manage/for-record',
          name: 'forCuvacion-record',
          component: forCuvacoinRecord,
          meta: {
            title: '兑换记录'
          }
        },
        {
          path: '/financial-manage/purchase-record',
          name: 'FinPurchase-record',
          component: FinPurchaseRecord,
          meta: {
            title: '购买记录'
          }
        },
        {
          path: '/financial-manage/kol-settle-manage',
          name: 'finKol-settle-record',
          component: FinKolSettleRecord,
          meta: {
            title: '购买记录'
          }
        },

        // ----- 财务管理路由
        // 排行榜
        {
          path: '/ranking-list',
          name: 'rankingList',
          component: rankingList,
          meta: {
            key: '/ranking-list',
            title: '排行榜'
          }
        },
        {
          path: '/ranking-list-model',
          name: 'rankingListModel',
          component: rankingListModel,
          meta: {
            key: '/ranking-list',
            title: '排行榜'
          }
        },
        {
          path: '/ranking-list-user',
          name: 'rankingListUser',
          component: rankingListUser,
          meta: {
            key: '/ranking-list',
            title: '排行榜'
          }
        },
        {
          path: '/ranking-list-black',
          name: 'rankingListBlack',
          component: rankingListBlack,
          meta: {
            key: '/ranking-list',
            title: '排行榜'
          }
        },
        // 建模师入驻
        {
          path: '/modelerIn',
          name: 'modelerIn',
          component: modelerIn,
          meta: {
            title: '建模师'
          }
        },
        // 参加建模师活动的建模师
        {
          path: '/modeler-in-activity',
          name: 'modelerInActivity',
          component: modelerInActivity,
          meta: {
            title: '最佳建模师'
          }
        },
        {
          path: '/pk-contestant-group',
          name: 'pkContestantGroup',
          component: pkContestantGroup,
          meta: {
            title: 'PK选手分组'
          }
        },
        {
          path: '/winter-contest',
          name: 'WinterContest',
          component: WinterContest,
          meta: {
            title: '冬季挑战赛投票记录'
          }
        },
        {
          path: '/photo-3d-order',
          name: 'photo3dOrder',
          component: photo3dOrder,
          meta: {
            title: '3D照片订单'
          }
        },
        // KOL审核管理
        {
          path: '/kol-manage',
          name: 'kolManage',
          component: kolManage,
          meta: {
            title: 'KOL审核管理'
          }
        },
        // KOL结算申请管理
        {
          path: '/kol-settle-manage',
          name: 'kolSettleManage',
          component: kolSettleManage,
          meta: {
            title: 'KOL结算申请管理',
            key: '/kol-manage'
          }
        },
        {
          path: '/special-thanks',
          name: 'specialThanks',
          component: specialThanks,
          meta: {
            title: '荣誉墙',
            key: '/special-thanks'
          }
        },
        {
          path: '/model-recruit/modeler',
          component: ModelRecruitModeler,
          meta: {
            title: '模型招募-建联池'
          }
        },
        {
          path: '/model-recruit/models',
          component: ModelRecruitModels,
          meta: {
            title: '模型招募-定价池'
          }
        },
        {
          path: '/model-recruit/modeler/uploaded-models',
          component: ModelRecruitModelerUploadedModels,
          meta: {
            title: '模型招募-已传模型用户'
          }
        },
        {
          path: '/model-recruit/modeler/1v1',
          component: ModelRecruitModeler1v1,
          meta: {
            title: '模型招募-1v1'
          }
        },
        {
          path: '/model-recruit/modeler/referral-rewards',
          component: ModelRecruitModelerReferralRewards,
          meta: {
            title: '模型招募-推荐获奖用户'
          }
        },
        {
          path: '/model-recruit/modeler/referred-users',
          component: ModelRecruitModelerReferredUsers,
          meta: {
            title: '模型招募-被推荐用户'
          }
        },
        {
          path: '/ai-times',
          name: 'aiTimes',
          component: aiTimes,
          meta: {
            title: '发放次数',
            key: '/ai-times'
          }
        },
        {
          path: '/settlement-config',
          name: 'settlementConfig',
          component: settlementConfig,
          meta: {
            title: '结算配置',
            key: '/settlement-config'
          }
        },
        {
          path: '/page-config',
          name: 'pageConfig',
          component: pageConfig,
          meta: {
            title: '页面配置',
            key: '/page-config'
          }
        },
        {
          path: '/brics-work',
          name: 'bricsWork',
          component: bricsWork,
          meta: {
            title: '参赛作品'
          }
        },
        {
          path: '/brics-contestant',
          name: 'bricsContestant',
          component: bricsContestant,
          meta: {
            title: '参赛选手'
          }
        },
        {
          path: '/brics-permission',
          name: 'bricsPermission',
          component: bricsPermission,
          meta: {
            title: '专家权限'
          }
        },
        {
          path: '/photo-3d-settlement',
          name: 'photo3dSettlement',
          component: photo3dSettlement,
          meta: {
            title: '3D照片推广收益提现管理',
            key: '/photo-3d-order'
          }
        },
        // 财务管理里面的 3D照片推广收益提现管理
        {
          path: '/financial-manage/photo-3d-settlement',
          name: 'photo3dSettlement1',
          component: photo3dSettlement,
          meta: {
            title: '3D照片推广收益提现管理'
          }
        },
        {
          path: '/slice-base-manage',
          name: 'slice-base-manage',
          component: sliceBaseManage,
          meta: {
            title: '切片元数据版本管理'
          }
        },
        {
          path: '/ui-level-manage',
          name: 'ui-level-manage',
          component: uiLevelManage,
          meta: {
            title: 'UI层级管理',
            key: '/slice-base-manage'
          }
        },
        {
          path: '/base-params',
          name: 'base-params',
          component: baseParams,
          meta: {
            title: 'Base数据',
            key: '/slice-base-manage'
          }
        },
        {
          path: '/slice-params-i18n',
          name: 'slice-params-i18n',
          component: sliceParamsI18n,
          meta: {
            title: '切片参数多语言',
            key: '/slice-base-manage'
          }
        },
        {
          path: '/consumable-manage',
          name: 'consumable-manage',
          component: consumableManage,
          meta: {
            title: '耗材管理'
          }
        },
        {
          path: '/process-params-manage',
          name: 'process-params-manage',
          component: processParamsManage,
          meta: {
            title: '工艺参数管理'
          }
        },
        {
          path: '/printer-params-manage',
          name: 'printer-params-manage',
          component: printerParamsManage,
          meta: {
            title: '机型参数包管理'
          }
        },
        {
          path: '/dlp-device-params-manage',
          name: 'dlp-device-params-manage',
          component: dlpDeviceParamsManage,
          meta: {
            title: '机型耗材参数'
          }
        },
        {
          path: '/dlp-resin-manage',
          name: 'dlp-resin-manage',
          component: dlpResinManage,
          meta: {
            title: '耗材列表',
            key: '/dlp-device-params-manage'
          }
        },
        {
          path: '/dlp-slice-params',
          name: 'dlp-slice-params',
          component: dlpSliceParams,
          meta: {
            title: '切片参数',
            key: '/dlp-device-params-manage'
          }
        },
        {
          path: '/dlp-layer-thick-manage',
          name: 'dlp-layer-thick-manage',
          component: dlpLayerThickManage,
          meta: {
            title: '层厚',
            key: '/dlp-device-params-manage'
          }
        },
        {
          path: '/three-params-manage',
          name: 'three-params-manage',
          component: threeParamsManage,
          meta: {
            title: '第三方参数包管理'
          }
        },
        {
          path: '/dtc/stockout-delayed-users',
          name: 'stockout-delayed-users',
          component: StockoutDelayedUsers,
          meta: {
            title: 'DTC券码发放用户列表',
            key: '/stockout-delayed-users'
          }
        },
        {
          path: '/coupon-package-manager',
          name: 'coupon-package-manager',
          component: CouponPackageManager,
          meta: {
            title: '优惠券包管理',
            key: '/coupon-package-manager'
          }
        },
        {
          path: '/inspiration-management',
          name: 'inspiration-management',
          component: InspirationManagement,
          meta: {
            title: '灵感管理'
          }
        },
        {
          path: '/official-creat-per-manage',
          name: 'official-creat-per-manage',
          component: OfficialCreatPerManage,
          meta: {
            title: '官方创作权限管理'
          }
        },
        {
          path: '/official-inspiration-manage',
          name: 'official-inspiration-manage',
          component: OfficialInspirationManage,
          meta: {
            title: '官方灵感管理'
          }
        },
        {
          path: '/operation-log',
          name: 'operation-log',
          component: OperationLog,
          meta: {
            title: '操作日志',
            key: '/operation-log'
          }
        },
        {
          path: '/shop-manage/order',
          name: 'shop-manage-order',
          component: ShopManageOrder,
          meta: {
            title: '订单中心',
            key: '/shop-manage/order'
          }
        },
        {
          path: '/shop-manage/goods',
          name: 'shop-manage-goods',
          component: ShopManageGoods,
          meta: {
            title: '商品管理',
            key: '/shop-manage/goods'
          }
        },
        {
          path: '*',
          component: NotFound
        }
      ]
    }
  ]
})
